"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDrillHeaders = exports.createDataColGroupHeaders = exports.createSliceColHeaders = exports.createDataColLeafHeaders = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var tableDescriptorTypes_1 = require("../structure/tableDescriptorTypes");
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var ts_invariant_1 = tslib_1.__importStar(require("ts-invariant"));
function createDataColLeafHeaders(col) {
    var mappingHeaders = [];
    if (col.seriesDescriptor.attributeDescriptors) {
        col.seriesDescriptor.attributeDescriptors.forEach(function (attributeDescriptor, index) {
            var attributeElementDescriptor = col.seriesDescriptor.attributeHeaders[index];
            mappingHeaders.push(attributeElementDescriptor);
            mappingHeaders.push(attributeDescriptor);
        });
    }
    mappingHeaders.push(col.seriesDescriptor.measureDescriptor);
    return mappingHeaders;
}
exports.createDataColLeafHeaders = createDataColLeafHeaders;
function createSliceColHeaders(col, row) {
    var result = [];
    var attributeElement = row.headerItemMap[col.id];
    ts_invariant_1.default(attributeElement, "unable to obtain attribute element for row of a slicing column " + col.id);
    ts_invariant_1.default(sdk_backend_spi_1.isResultAttributeHeader(attributeElement), "bad header for row data " + col.id);
    result.push(attributeElement);
    result.push(col.attributeDescriptor);
    return result;
}
exports.createSliceColHeaders = createSliceColHeaders;
function createDataColGroupHeaders(col) {
    var mappingHeaders = [];
    col.descriptorsToHere.forEach(function (descriptor, index) {
        mappingHeaders.push(col.headersToHere[index]);
        mappingHeaders.push(descriptor);
    });
    mappingHeaders.push(col.header);
    mappingHeaders.push(col.attributeDescriptor);
    return mappingHeaders;
}
exports.createDataColGroupHeaders = createDataColGroupHeaders;
/**
 * Given column and optionally a grid row, this function will collect all descriptors and headers
 * to create 'mapping headers' that can be used for matching the column against drill predicates.
 *
 * Note: the row is optional and will only be needed when constructing headers for slicing columns (e.g. columns
 * that contain slicing attribute elements) - as the attribute element headers are in the row data.
 *
 * @param col - column to get mapping headers for
 * @param row - row
 */
function createDrillHeaders(col, row) {
    if (tableDescriptorTypes_1.isSeriesCol(col)) {
        return createDataColLeafHeaders(col);
    }
    else if (tableDescriptorTypes_1.isScopeCol(col)) {
        return createDataColGroupHeaders(col);
    }
    else if (tableDescriptorTypes_1.isSliceCol(col)) {
        // if this bombs, then the client is not calling the function at the right time. in order
        // to construct drilling headers for a slice col, both the column & the row data must be
        // available because the attribute element (essential part) is only available in the data itself
        ts_invariant_1.default(row);
        return createSliceColHeaders(col, row);
    }
    throw new ts_invariant_1.InvariantError("unable to obtain drill headers for column of type " + col.type);
}
exports.createDrillHeaders = createDrillHeaders;
//# sourceMappingURL=colDrillHeadersFactory.js.map